import { useRef } from 'react'
import useAppAlertMessageAction from '../../../../stores/appAlertMessage/appAlertMessageAction'
import useTranslate from '../../../../i18n/useTranslate'
const useDialogPlayground = () => {
    const dialogOneRef = useRef<Record<string, Function>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const translate = useTranslate()
    const appAlertMessageAction = useAppAlertMessageAction()

    const handleRefDialogOne = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogOneRef.current = func
    }
    const handleRefDialogTwo = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogTwoRef.current = func
    }

    const handleClickDialogOne = () => {
        dialogOneRef.current?.openDialog()
    }
    const handleClickDialogTwo = () => {
        dialogTwoRef.current?.openDialog()
    }
    const handleClickApplicationAlertMessage = () => {
        appAlertMessageAction.openAlertMessage({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            message: 'Test Alert Message Application.',
        })
    }
    return {
        //props
        //Event
        onRefDialogOne: handleRefDialogOne,
        onRefDialogTwo: handleRefDialogTwo,
        onClickDialogOne: handleClickDialogOne,
        onClickDialogTwo: handleClickDialogTwo,
        onClickApplicationAlertMessage: handleClickApplicationAlertMessage,
    }
}

export default useDialogPlayground
